import { useMemo } from 'react';

import { useDataProvider } from '@work4all/data';

import { Position } from '@work4all/models/lib/Classes/Position.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { BzObjType } from '@work4all/models/lib/Enums/BzObjType.enum';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const POSITION_FIELDS: Position<EMode.query> = {
  id: null,
  bzObjType: null,
  bzObjMemberId: null,
  longtext: null,
  number: null,
  singlePriceNet: null,
  totalPriceNet: null,
  amount: null,
  unit: null,
  purchasePrice: null,
  details: {
    bz_Number: null,
    bz_Date: null,
    bz_Company_Name: null,
    bz_Company_Number: null,
    bz_Project_Name: null,
    bz_Project_Number: null,
    bz_ProjektCode: null,
    bz_Currency: null,
    pos_BzObjType: null,
  },
};

export const usePositionData = (props: {
  positionIdList: number[];
  bzObjType: BzObjType;
}) => {
  const { positionIdList, bzObjType } = props;

  const req = useMemo<DataRequest>(() => {
    return {
      entity: Entities.position,
      data: POSITION_FIELDS,
      filter: [
        {
          id: {
            $in: positionIdList,
          },
        },
      ],
      vars: {
        bzObjType,
      },
    };
  }, [bzObjType, positionIdList]);

  return useDataProvider<Position>(req);
};
